import type { ValueOf } from '@amp/web-app-components/src/types';
import { LibraryListPageType } from '~/jet/models';

// Tab Ids
const HOME_ID = { type: 'home' } as const;
const BROWSE_ID = { type: 'browse' } as const;
const SEARCH_ID = { type: 'search' } as const;

// Library
export const ALL_PLAYLISTS_ID = { type: 'all-playlists' } as const;
export const ALBUMS_ID = { type: 'albums' } as const;
export const ARTISTS_ID = { type: 'artists' } as const;
export const COMPOSERS_ID = { type: 'composers' } as const;
export const RECENTLY_ADDED_ID = { type: 'recently-added' } as const;
export const RECORDINGS_ID = { type: 'recordings' } as const;
export const TRACKS_ID = { type: 'tracks' } as const;
export const WORKS_ID = { type: 'works' } as const;

export type PlaylistItemId = { type: 'playlist'; resourceId: string };

export const TAB_IDs = {
    home: HOME_ID,
    browse: BROWSE_ID,
    search: SEARCH_ID,
} as const;

export type LibraryItemId =
    | typeof ALBUMS_ID
    | typeof ALL_PLAYLISTS_ID
    | typeof ARTISTS_ID
    | typeof COMPOSERS_ID
    | typeof RECENTLY_ADDED_ID
    | typeof RECORDINGS_ID
    | typeof TRACKS_ID
    | typeof WORKS_ID;

export type TabId = ValueOf<typeof TAB_IDs> | LibraryItemId | PlaylistItemId;

export const LIBRARY_TABS = [
    ALL_PLAYLISTS_ID,
    ALBUMS_ID,
    ARTISTS_ID,
    COMPOSERS_ID,
    RECENTLY_ADDED_ID,
    RECORDINGS_ID,
    TRACKS_ID,
    WORKS_ID,
].map(({ type }) => type);

export const LIBRARY_LIST_PAGE_TO_TAB_ID = {
    [LibraryListPageType.Album]: ALBUMS_ID,
    [LibraryListPageType.Artist]: ARTISTS_ID,
    [LibraryListPageType.Composer]: COMPOSERS_ID,
    [LibraryListPageType.Recording]: RECORDINGS_ID,
    [LibraryListPageType.Track]: TRACKS_ID,
    [LibraryListPageType.Work]: WORKS_ID,
};
